import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { Section } from './NewRefreshResultsModal';

const AssignedTasksModal = ({ open, onClose, rows }) => {
  const navigate = useNavigate();

  const handleRowClick = (verticalId) => {
    onClose();
    navigate(`/vertical/${verticalId}/workbench/vertical?tab=tasks`);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth style={{ padding: 12 }}>
      <DialogTitle
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 700,
        }}
      >
        Assigned Tasks
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Section
          nameLabel="Joined Vertical Name"
          countLabel="Number of Assigned Tasks"
          rows={rows}
          onRowClick={handleRowClick}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AssignedTasksModal;
